import Vue from 'vue'
import VueRouter from 'vue-router' //1、引入VueRouter 
Vue.use(VueRouter) //2、使用VueRouter



// 主路由（一）首页路由页面
import Main from './page/Main.vue'
import home from './page/main/index.vue'
import lookBack from './page/main/lookBack.vue'
import share from './page/main/share.vue'

// 首页打卡栏子路由页面
import card from './page/main/card.vue'

// 主路由（二）打卡详情页面
import Detail from './page/Detail.vue'
import Introduce from './page/Detail/detail_Introduce.vue'
import apply from './page/Detail/detail_appyl.vue'
import study from './page/Detail/study.vue'
import shareChild from './page/Detail/shareChild.vue'
// 图文页面
import imageText from './page/Detail/image_text'
//主路由（三） 刷题页面
import text from "./page/text.vue"


//主路由（四）视频学习页面
import video from "./page/video.vue"

import fontpage from "./page/error.vue"

// 主路由（五）个人中心页面
import Home from "./page/Home.vue"

var applyTitle = '报名详情'

const routes = [ //4、配置路由
    {
        path: '/',
        redirect: "/index/home/card/0"
    },
    {
        path: '/index',
        redirect: "/index/home/card/0"
    },
    // 双端适配路由重定向部分开始——————————————————————————————
    {
        // 往期回顾部分
        path: '/periods',
        redirect: "/index/lookBack"
    },
    {
        // 评论详情部分
        path: '/showdeatalist/:id',
        redirect: "/Detail/shareChild/:id"
    },
    {
        // 排行榜部分
        path: '/ranking/:id',
        redirect: "/index/share"
    },
    {
        // 分享页面
        path: '/share',
        redirect: "/index/share"
    },

    {
        // 分享详情页
        path: '/shareDetail/:id',
        redirect: "/Detail/shareChild/:id"
    },
    {
        // 报名详情页
        path: '/topdeatil/:id',
        redirect: "/Detail/apply/:id"
    },
    {
        // 已报名页面
        path: '/topdeatil/:id',
        redirect: "/Detail/study/:id"
    },
    {
        // 打卡日记页面
        path: '/applyslide_detial/:id',
        redirect: "/Detail/study/:id"
    },
    {
        // 日历页面跳学习页
        path: '/rankiClad/:id',
        redirect: "/Detail/study/:id"
    },
    {
        // 个人打卡日记部分
        path: '/my_diary/:id',
        redirect: "/home/:id"
    },
    // 图文打卡模式
    {
        path: "/ageText/:id",
        redirect: "/Detail/imageText/:id"
    }, // 图文打卡模式
    {
        path: "/age_test/:id",
        redirect: "/Detail/LookImageText/:id"
    },

    {
        path: '/shareChildDetail',
        redirect: "/"
    },
    {
        path: '/mycomment',
        redirect: "/"
    },
    {
        path: '/entrance',
        redirect: "/"
    },
    {
        path: '/myGiveLike',
        redirect: "/"
    },
    {
        path: '/activity',
        redirect: "/"
    },
    {
        path: '/GiveLikeMy',
        redirect: "/"
    },
    {
        path: '/punch',
        redirect: "/"
    },
    // 双端适配路由重定向部分结束——————————————————————————————
    {
        // index为一级路由这里的index展示的为主页面
        path: '/index',
        component: Main,
        meta: {
            title: "特训营"
        },
        children: [{
                // index下的home为二级路由这里二级路由主要变化的是在主页面下的打卡和往期回顾等路由之间的跳转
                path: '/index/home',
                component: home,
                children: [{
                    // 这里card为三级路由主要是在首页的基础上有一个打卡窗口，
                    path: "/index/home/card/:id",
                    component: card,
                    meta: {
                        title: "特训营-首页"
                    },
                }]
            },
            {
                path: "/index/lookBack",
                component: lookBack,
                meta: {
                    title: "特训营-往期回顾"
                },
            },
            {
                path: "/index/share",
                component: share,
                meta: {
                    title: "特训营-日记"
                },
            }
        ]
    },
    // detail为一级路由的详情页面
    {
        path: "/Detail",
        redirect: "/Detail/Introduce",
    },
    {
        path: "/Detail",
        component: Detail,
        children: [{
                // 这里为打卡详情页
                path: "/Detail/Introduce/:id",
                component: Introduce,
                meta: {
                    title: "特训营-详情"
                },
            },
            {
                // 这里为报名详情页
                path: "/Detail/apply/:id",
                component: apply,
                meta: {
                    title: applyTitle,
                },
            }, {
                // 这里为学习详情页
                path: "/Detail/study/:id",
                component: study,
                meta: {
                    title: "特训营-学习页面",
                    requireAuth: true
                },
            },
            {
                // 分享详情页
                path: "/Detail/shareChild/:id",
                component: shareChild,
                meta: {
                    title: "特训营-日记详情"
                },
            },
            {
                // 图文刷题页面
                path: "/Detail/imageText/:id",
                component: imageText,
                meta: {
                    title: "图文刷题"
                },
            },
            {
                // 图文试看页面
                path: "/Detail/LookImageText/:id",
                component: () =>
                    import ("./page/Detail/Look_image_text"),
                meta: {
                    title: "购前必读"
                },
            }
        ]
    },
    // text为一级路由的刷题页面
    {
        path: "/text/:id",
        component: text,
        meta: {
            title: "特训营-开始学习",
            requireAuth: true
        },
    },
    // video为一级路由的视频学习页面
    {
        path: "/video/:id",
        component: video,
        meta: {
            title: "特训营-开始学习",
            requireAuth: true
        },
    },
    // Home为一级路由的个人中心页面
    {
        path: "/home/:id",
        component: Home,
        meta: {
            title: "特训营-日记",
        },
    },
    {
        path: "*",
        component: fontpage
    }
]


// 全局监听路由
// VueRouter.beforeEach((to, from, next) => {
//     console.log(to);
//     console.log(from);
//     next();
// });


//5、实例化VueRouoter
export default new VueRouter({
    // mode: 'history',
    routes //缩写 相当于 routes:routes
})